import React from 'react';
import { Container, NavigationScroll } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { useSelector } from 'react-redux';

const Header = () => {

  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  return (
    <NavigationScroll>
      <header>
        <Container large className="Header__container">
          <div className="Header">
            <div className="Header__logo">
              <CoreLink to={`/${currentLanguage}`}>
                <div className={`Header__logo__img ${currentLanguage === 'nl' ? 'nl-logo' : ''}`} />
              </CoreLink>
            </div>
          </div>
        </Container>
      </header>
    </NavigationScroll>
  );
};

export default Header;
